// extracted by mini-css-extract-plugin
export default {"container":"OV-z","title":"PV-z","link":"QV-z"};